import { fabric } from 'fabric';

const PolicyLabel = fabric.util.createClass(fabric.Text, {
  initialize: function (...params: [text: string, options: fabric.LabelOptions] | [fabric.Object]) {
    if (params.length === 1) {
      const obj = params[0] as fabric.PolicyLabel;
      this.label = obj.label;
      this.callSuper('initialize', obj.text, obj);
    } else if (params.length === 2) {
      const text = params[0];
      const options = params[1];
      this.label = options.label;
      this.callSuper('initialize', text, options);
    }
  },
  toObject: function () {
    return fabric.util.object.extend(this.callSuper('toObject'), { label: this.label });
  },
});

PolicyLabel.fromObject = function (object: fabric.Object, callback: (obj: fabric.Object) => void) {
  const label = new PolicyLabel(object);
  if (callback) callback(label);
  return label;
};

export default PolicyLabel;
